export enum NotificationTypeEnum {
  ASSIGNMENT = 'ASSIGNMENT',
  VALIDATION = 'VALIDATION',
  REJECTION = 'REJECTION',
  CRITICAL_ALERT = 'CRITICAL_ALERT',
  TRANSFER = 'TRANSFER',
  NEW_COMPLAINT = 'NEW_COMPLAINT'
}
export const NotificationTypeEnumList = [
  { name: "Assignation", code: NotificationTypeEnum.ASSIGNMENT },
  { name: "Validation", code: NotificationTypeEnum.VALIDATION },
  { name: "Rejeté", code: NotificationTypeEnum.REJECTION },
  { name: "Alerte critique", code: NotificationTypeEnum.CRITICAL_ALERT },
  { name: "Transfert", code: NotificationTypeEnum.TRANSFER },
  { name: "Nouveau plainte", code: NotificationTypeEnum.NEW_COMPLAINT },
];


export interface NotificationDTO {
  id: number;
  name: string;
  description: string;
  link: string;
  type: NotificationTypeEnum;
  createdAt: string;
}

export interface UserNotification {
  id: number;
  userId: number;
  notificationDto: NotificationDTO;
  read: boolean;
}
